import React from "react";
import { heroCertificate, CHAIN, totalStats } from "../mock";
import Guilloche, { WavyRule } from "./Guilloche";
import { ArrowRight } from "lucide-react";

const fmt = (n) => n.toLocaleString("en-US");

const COUNTERFOIL = [
  { k: "Certificates", v: String(totalStats.certificates) },
  { k: "Issued on", v: "Zcash mainnet" },
  { k: "Destroyed on", v: CHAIN.name },
  { k: "Launchpad", v: CHAIN.launchpad },
  { k: "Reissuable", v: "No" },
  { k: "Held by us", v: "Nothing" },
];

export default function Hero() {
  return (
    <section id="top" className="container-x pt-6 pb-16">
      <div className="paper paper-grain rounded-sm fade-up">
        <div className="grid lg:grid-cols-[1fr_240px]">
          {/* MAIN */}
          <div className="relative overflow-hidden p-7 md:p-12">
            {/* guilloche decorations */}
            <Guilloche size={320} opacity={0.35} className="absolute -bottom-16 right-4 pointer-events-none hidden md:block" />
            <Guilloche size={150} opacity={0.3} className="absolute bottom-6 right-40 pointer-events-none hidden lg:block" />

            <div className="relative">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h1 className="font-number font-semibold tracking-tight" style={{ fontSize: "clamp(1.9rem,4vw,3rem)", lineHeight: 1.05 }}>Certificate of Destruction</h1>
                  <div className="label mt-2">No. 000001</div>
                </div>
                <div className="cancelled-stamp px-4 py-2 font-semibold shrink-0" style={{ fontSize: "clamp(1rem,2.4vw,1.6rem)" }}>CANCELLED</div>
              </div>

              <WavyRule className="my-7" />

              <p className="text-[15px] leading-relaxed max-w-xl" style={{ color: "var(--text)" }}>
                The quantity below was irreversibly destroyed on {CHAIN.name}. This inscription records it on Zcash and cannot be reissued.
              </p>

              <div className="mt-8">
                <div className="label">Quantity destroyed</div>
                <div className="font-number font-semibold" style={{ fontSize: "clamp(3rem,9vw,6.2rem)", lineHeight: 1, letterSpacing: "-0.02em" }}>{fmt(heroCertificate.quantity)}</div>
                <div className="text-[14px] mt-2" style={{ color: "var(--muted)" }}>tokens destroyed across {totalStats.certificates} coins, each one certified on Zcash</div>
              </div>

              <h2 className="font-number font-medium mt-10 max-w-2xl" style={{ fontSize: "clamp(1.4rem,3vw,2.1rem)", lineHeight: 1.2 }}>
                Burn STAMP on {CHAIN.name}. Keep a certificate on Zcash stamped with exactly what you destroyed.
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed max-w-xl" style={{ color: "var(--muted)" }}>
                One way. No escrow, no custody, nobody holding your funds. The tokens stop existing; the certificate is the only thing left.
              </p>
              <p className="mt-5 font-mono text-[12px] leading-relaxed max-w-md break-all" style={{ color: "var(--muted)" }}>
                Real, on Zcash mainnet. Inscription {heroCertificate.inscription}
              </p>

              <a href="#burn" className="inline-flex items-center gap-2 mt-8 h-12 px-8 nav-link transition-transform hover:-translate-y-0.5"
                 style={{ background: "var(--red)", color: "#fff", letterSpacing: "0.14em", fontSize: 13 }}>
                Burn yours <ArrowRight size={15} />
              </a>
            </div>
          </div>

          {/* COUNTERFOIL */}
          <aside className="perf-v p-7 md:p-9" style={{ background: "rgba(255,255,255,0.008)" }}>
            <div className="label" style={{ color: "var(--gold)" }}>Counterfoil</div>
            <div className="mt-6 flex flex-col gap-6">
              {COUNTERFOIL.map((row) => (
                <div key={row.k}>
                  <div className="label">{row.k}</div>
                  <div className="font-mono text-[13px] mt-1" style={{ color: "var(--text)" }}>{row.v}</div>
                </div>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
